<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label=" Page ii. " class="page" epub:type="pagebreak" id="pii" role="doc-pagebreak"></span><span aria-label=" Page iii. " class="page" epub:type="pagebreak" id="piii" role="doc-pagebreak"></span>Your Comrade, Avreml Broide</h1>
<h1 class="bk1">A Worker’s Life Story</h1>
<p class="bkau">A Novel by Ben Gold</p>
<p class="bkau1">Translated by Annie Sommer Kaufman</p>
<p class="bkau1">Illustrations by William Gropper</p>
<h1 class="bk2">A Yiddish Book Center Translation</h1>
<p class="bkpub"><img alt="Wayne State University Press logo" height="50" src="images/wsu-logo.jpg" width="50"/></p>
<p class="bkpub1">Wayne State University Press</p>
<p class="bkpub1">Detroit</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-gold-0003.vue?02c14a58